/**
 * AppShellFallback — branded first-paint Suspense fallback.
 *
 * Used while the initial JS chunks finish loading on a hard refresh, so the
 * user sees the Sirppi logo + a shimmer bar instead of a white screen.
 * After first successful render, App swaps to the slim PageSkeleton bar
 * for in-app navigations (which preserves the previous page underneath).
 */
import logo from '@/assets/sirppi-logo.svg';

export const AppShellFallback = () => {
  return (
    <div
      aria-hidden="true"
      className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-background"
      data-testid="app-shell-fallback"
    >
      <img
        src={logo}
        alt=""
        className="w-16 h-16 mb-6 opacity-90"
        loading="eager"
        decoding="async"
      />
      <div className="w-40 h-1 rounded-full overflow-hidden bg-muted">
        <div
          className="h-full bg-primary"
          style={{
            width: '40%',
            animation: 'app-shell-progress 1.1s ease-in-out infinite',
          }}
        />
      </div>
      <style>{`
        @keyframes app-shell-progress {
          0%   { transform: translateX(-150%); }
          60%  { transform: translateX(200%); }
          100% { transform: translateX(400%); }
        }
      `}</style>
    </div>
  );
};

export default AppShellFallback;
